import { ICommand } from 'core-ts-types';
import { ScheduledPollQuery } from './../queries/scheduled_poll_query';

export class CheckScheduledPollsServant {
  public query: ScheduledPollQuery;
  public _route: string;
  public _defaultRoute: string;

  constructor(private ngScheduledPollQuery: ScheduledPollQuery, private loadScheduledPollsCommand: ICommand) {
    this._route = '';
    this.query = this.ngScheduledPollQuery;
  }

  set route(stateName: string) {
    this._route = stateName;
  }

  get route(): string {
    return this._route;
  }

  set defaultRoute(stateName: string) {
    this._defaultRoute = stateName;
  }

  get defaultRoute(): string {
    return this._defaultRoute;
  }

  hasScheduledPolls(): boolean {
    return this.query.hasScheduledPolls();
  }

  load(): ng.IPromise<any> {
    return this.loadScheduledPollsCommand();
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/servants/check_scheduled_poll_servant.ts